(() => {
  if (window.fsSlideCartInitialized) return;
  window.fsSlideCartInitialized = true;

  const showError = (form, message) => {
    let error = form.querySelector('[data-fs-cart-error]');

    if (!error) {
      error = document.createElement('p');
      error.className = 'fs-cart__error';
      error.dataset.fsCartError = '';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }

    error.textContent = message;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (
      event.defaultPrevented ||
      !(form instanceof HTMLFormElement) ||
      !form.matches('form[action$="/cart/add"], form[action$="/cart/add.js"]')
    ) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    event.preventDefault();
    if (form.dataset.fsCartSubmitting === 'true') return;

    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-fs-cart-error]');
    const originalButtonHtml = button ? button.innerHTML : '';

    form.dataset.fsCartSubmitting = 'true';
    if (error) error.remove();

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding to cart...';
    }

    try {
      const formData = new FormData(form);
      const sections = cartDrawer.getSectionsToRender().map((section) => section.id).join(',');
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement(document.activeElement);

      const addUrl = form.action.endsWith('.js') ? form.action : `${form.action}.js`;
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      let result = null;

      try {
        result = await response.json();
      } catch (_) {
        result = null;
      }

      if (!response.ok || !result || result.status) {
        throw new Error(result?.description || 'This bundle could not be added. Please try again.');
      }

      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(result);
    } catch (error) {
      showError(form, error.message || 'This bundle could not be added. Please try again.');
    } finally {
      delete form.dataset.fsCartSubmitting;

      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = originalButtonHtml;
      }
    }
  });
})();
